// Generated by DesignToCode

import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Card } from '../../ui/card/card';

export type CardItem = {
  title: string;
  description: string;
};

@Component({
  selector: 'app-how-we-work',
  standalone: true,
  imports: [CommonModule, Card],
  templateUrl: './how-we-work.html',
})
export class HowWeWork {
  bgStyle: string;

  constructor(@Inject(DOCUMENT) document: Document) {
    const baseHref = document.querySelector('base')?.getAttribute('href') ?? '/';
    this.bgStyle = `url('${baseHref}gradient.webp')`;
  }
}
